import { render } from "./Idea.vue?vue&type=template&id=73a5350b"
import script from "./Idea.vue?vue&type=script&lang=js"
export * from "./Idea.vue?vue&type=script&lang=js"
script.render = render

export default script